/**
 * Adds a screen-reader only div to the bottom of the body with
 * aria-live="polite". Div is removed after a few seconds so user is unlikely to
 * tab to it.
 *
 * @param {string} message - The string to be read by the screen reader
 */
export default function announce(message, liveSetting = 'polite') {
    if (typeof message !== 'string') {
        return;
    }
    // amount of time message should stay in the DOM.
    // Two seconds plus extra based on the length of the message
    const timeout = 2000 + message.length * 150;
    const el = document.createElement('div');
    
    el.setAttribute('aria-live', liveSetting);
    el.style.cssText = `
        position: absolute !important;
        clip: rect(1px, 1px, 1px, 1px);
        clipPath: inset(50%);
        padding: 0;
        border: 0;
        height: 1px;
        width: 1px;
        overflow: hidden;
        whiteSpace: nowrap;
    `;
    
    document.body.appendChild(el);
    
    el.innerHTML = message;
    
    
    setTimeout(() => {
        el.remove();
    }, timeout)
}